import axios from 'axios'
import { ADMIN_API_URL } from 'const'

const BASE_URL = `${ADMIN_API_URL}/stream/controls`

// A refusal names each control it refused and why (422), or says another
// save landed first (409); either way nothing was written.
const reason = (err) => {
  const detail = err.response?.data?.detail
  if (detail && typeof detail === 'object' && !Array.isArray(detail))
    return Object.entries(detail)
      .map(([control, why]) => `${control}: ${why}`)
      .join(' · ')
  if (Array.isArray(detail)) return detail.map(({ msg }) => msg).join(' · ')
  return detail || err.message
}

// The Cost page's spend gates: every control's value in force, Terraform's
// default and whether staff overrode it, plus the change log, newest first.
export const getControls = async () => {
  try {
    const { data } = await axios.get(BASE_URL)
    return data
  } catch (err) {
    throw new Error(reason(err))
  }
}

// Set `changes` ({control: value}) and give `reset` ([control]) back to
// Terraform's value. `reason` is required: the change log keeps it. Answers
// the same view as `getControls`; a change applies from the next pass.
export const saveControls = async ({
  changes = {},
  reset = [],
  reason: why,
}) => {
  try {
    const { data } = await axios.put(BASE_URL, { changes, reset, reason: why })
    return data
  } catch (err) {
    throw new Error(reason(err))
  }
}
